import { Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useLayoutContext } from '../../../Context/Layout.context';
import usePermission, { UserPermission } from '../../../hooks/usePermission';
import {
  getConfigurationApi,
  getConfigurationApiDetails,
} from '../../../services/admin/settings/systemSettings.service';
import ActionsMenu from '../../ActionsMenu/ActionsMenu.component';
import { ActionMenuItem } from '../../ActionsMenu/ActionsMenu.types';
import { SelectableTable } from '../../SelectableTable/SelectableTable.component';
import { SelectableTableColumn } from '../../SelectableTable/SelectableTable.types';
import { useStyles } from './ConfigurationApi.styles';
import { ConfigurationApiListItem, ConfigurationApiDetails, ConfigurationApiTableItem } from './configurationApi.types';
import { EditApiSettings } from './EditConfigurationApi.component';
import { ConfigurationOkeDetails } from '../ConfigurationOke/ConfigurationOke.types';
import { useTranslation } from 'react-i18next';
interface ConfigurationApiProps {
  onClose: () => void;
  onChange: () => void;
}

export const ConfigurationApi: React.FC<ConfigurationApiProps> = () => {
  const classes = useStyles();

  const { showLoader } = useLayoutContext();
  const { t } = useTranslation();

  const [configurationApiList, setConfigurationApiList] = useState<ConfigurationApiListItem[]>([]);
  const [data, setData] = useState<ConfigurationApiTableItem[]>([]);
  const [isEditAppSettingsModalOpen, setIsEditAppSettingsModalOpen] = useState<boolean>(false);
  const [configurationApiDetails, setConfigurationApiDetails] = useState<ConfigurationApiDetails>();

  const hasAdminSettingsManagePermission = usePermission(UserPermission.AdminSettingsManage);

  const getData = () => {
    showLoader(true);
    getConfigurationApi()
      .then((result: ConfigurationApiListItem[]) => {
        if (result) {
          setConfigurationApiList(result);
        }
      })
      .finally(() => {
        showLoader(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleGetConfigurationApiDetails = (id: string) => {
    if (id) {
      showLoader(true);
      getConfigurationApiDetails(id)
        .then((result: ConfigurationApiDetails) => {
          if (result) {
            setConfigurationApiDetails(result);
            setIsEditAppSettingsModalOpen(true);
          }
        })
        .finally(() => {
          showLoader(false);
        });
    }
  };

  const handleOnClose = () => {
    setIsEditAppSettingsModalOpen(false);
    getData();
  };

  const getActionsMenuIcon = (id: string) => {
    const items: ActionMenuItem[] = [];
    if (hasAdminSettingsManagePermission) {
      items.push({
        text: 'Edytuj',
        onClick: () => {
          handleGetConfigurationApiDetails(id);
        },
      });
    }
    return <ActionsMenu menuItems={items} />;
  };

  // convert data for the tables
  useEffect(() => {
    if (configurationApiList.length) {
      const tableData: ConfigurationApiTableItem[] = configurationApiList.map((row: ConfigurationApiListItem) => ({
        name: row.name,
        description: row.description,
        actions: getActionsMenuIcon(row.configurationApiId),
      }));
      setData(tableData);
    }
  }, [configurationApiList]);

  const columns: SelectableTableColumn[] = [
    {
      id: 'name',
      type: 'text',
      title: 'Nazwa',
      filterType: null,
    },
    {
      id: 'description',
      type: 'text',
      title: 'Opis systemu',
      filterType: null,
    },
    {
      id: 'actions',
      type: 'actions',
      title: 'Akcje',
      filterType: null,
      skipEnterMethod: true,
    },
  ];

  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.tabTitle}>Konfiguracja API</Typography>
        <div className={classes.tableContainerFlex}>
          <SelectableTable<ConfigurationApiTableItem>
            columns={columns}
            rows={data}
            caption="Konfiguracja API"
          />
        </div>
        {isEditAppSettingsModalOpen && configurationApiDetails && (
          <EditApiSettings
            title={'Edytuj API'}
            data={configurationApiDetails}
            onCancel={() => setIsEditAppSettingsModalOpen(false)}
            onClose={handleOnClose}
          />
        )}
      </Grid>
    </>
  );
};
